module.exports = __webpack_public_path__ + "static/media/5-a2.a3cccf58.jpg";